import React from 'react';

import MenuItem from 'app/shared/layout/menus/menu-item';

import { NavDropdown } from './menu-components';

const adminMenuItems = () => (
  <>
    <MenuItem icon="chart-line" to="/admin/dashboard">
      Panel
    </MenuItem>
    <MenuItem icon="users" to="/admin/user-management">
      Gestión de usuarios
    </MenuItem>
    <MenuItem icon="building" to="/admin/businesses">
      Negocios
    </MenuItem>
    <MenuItem icon="calendar-check" to="/admin/bookings">
      Reservas
    </MenuItem>
    <MenuItem icon="credit-card" to="/admin/subscriptions">
      Suscripciones
    </MenuItem>
    <MenuItem icon="tag" to="/admin/coupons">
      Cupones
    </MenuItem>
    <MenuItem icon="mobile-screen" to="/admin/app-version">
      Versión de la app
    </MenuItem>
    <MenuItem icon="tachometer-alt" to="/admin/metrics">
      Métricas
    </MenuItem>
    <MenuItem icon="heart" to="/admin/health">
      Salud
    </MenuItem>
    <MenuItem icon="cogs" to="/admin/configuration">
      Configuración
    </MenuItem>
    <MenuItem icon="tasks" to="/admin/logs">
      Logs
    </MenuItem>
  </>
);

const openAPIItem = () => (
  <MenuItem icon="book" to="/admin/docs">
    API
  </MenuItem>
);

export const AdminMenu = ({ showOpenAPI }) => (
  <NavDropdown icon="users-cog" name={'Administración'} id="admin-menu" data-cy="adminMenu">
    {adminMenuItems()}
    {showOpenAPI && openAPIItem()}
  </NavDropdown>
);
